'use client';

import { signOut } from '@lichtblick/auth';
import { useTranslation } from '@lichtblick/i18next';
import { EXTERNAL_URLS } from '@lichtblick/utils';

import { Button } from '../Button';
import { NoRolesContainer, NoRolesLink } from '../CommonStyles/NoRoles.styles';
import { Error } from '../ErrorMessage/images/Error';

export const NoRolesLogout = () => {
  const { t } = useTranslation('login');

  return (
    <div>
      <NoRolesContainer>
        <Error />
        <p>
          {t('noRoles')}
          <NoRolesLink href={EXTERNAL_URLS.WIKI_ACCESS}>{t('page')}</NoRolesLink>
        </p>
        <Button label="Logout" onClick={() => signOut({ callbackUrl: '/' })} />
      </NoRolesContainer>
    </div>
  );
};
